export interface RestrictionScheduleLike {
  scheduleId: string;
  scheduleStartTimeUtc?: string | null;
  stringSchedule_StartTime: string;
  scheduleTimeRestrictionIsActive?: boolean; // only true when BIT=1
  submissionHrWindow?: number | null;
  notificationRejectionMessage?: string | null;
}

export interface RestrictionEvaluation {
  blocked: boolean;
  message?: string;
  diffHours?: number; // for debugging/logging
}

/**
 * Evaluates whether a schedule submission should be blocked.
 * Rules:
 *  - Active only if scheduleTimeRestrictionIsActive === true.
 *  - Window must be > 0.
 *  - Uses scheduleStartTimeUtc (preferred) falling back to stringSchedule_StartTime.
 *  - Blocks when diffHours <= window (includes past start).
 */
export function evaluateScheduleRestriction(
  schedule: RestrictionScheduleLike | undefined,
  now: Date = new Date()
): RestrictionEvaluation {
  if (!schedule) return { blocked: false };

  if (!schedule.scheduleTimeRestrictionIsActive) return { blocked: false };
  const window = schedule.submissionHrWindow;
  if (window == null || isNaN(Number(window)) || Number(window) <= 0) return { blocked: false };

  const raw = schedule.scheduleStartTimeUtc ?? schedule.stringSchedule_StartTime;
  if (!raw) return { blocked: false };

  const start = /[TZ]/i.test(raw) ? new Date(raw) : new Date(raw + 'Z');
  if (isNaN(start.getTime())) return { blocked: false };

  const diffHours = (start.getTime() - now.getTime()) / 3600000;
  if (diffHours <= Number(window)) {
    return {
      blocked: true,
      message:
        schedule.notificationRejectionMessage ||
        `You cannot submit a notification within ${window} hour(s) of the scheduled start time.`,
      diffHours
    };
  }
  return { blocked: false, diffHours };
}
